import { assoc, compose, pick } from 'ramda'

// `pick` drops `id` when the config row doesn't exist yet (new project), so `upsertConfig`
// creates it instead of colliding with another row.
export const cleanRequest = item => {
  return compose(
    pick(['id', 'name', 'value']), //
    assoc('value', JSON.stringify(item.value || []))
  )(item)
}
